import {NgModule} from '@angular/core';
import {ButtonPrimitiveComponent} from './button-primitive.component';

@NgModule({
  declarations: [ButtonPrimitiveComponent],
  exports: [ButtonPrimitiveComponent],
})
export class ButtonPrimitiveModule {}
